/**
 * Irregular English the answer matcher needs to know, whether or not a
 * lesson prints it (2026-10-08 sweeps): a slip between these forms — "she
 * can sang", "I drunk tea", "the men is", "my parent are" — is grammar, not a
 * typo. Shared by content/knownWords.ts (the word list) and matchAnswer.ts
 * (past forms never take a grammar -s).
 */

/** base · past · participle */
const VERBS = `
be was been  begin began begun  break broke broken  bring brought brought
buy bought bought  catch caught caught  choose chose chosen  come came come
become became become  cost cost cost  cut cut cut  do did done  drink drank drunk
drive drove driven  eat ate eaten  fall fell fallen  feed fed fed  feel felt felt
find found found  fly flew flown  forget forgot forgotten  get got got
give gave given  go went gone  grow grew grown  have had had  hear heard heard
hold held held  keep kept kept  know knew known  leave left left  lose lost lost
make made made  meet met met  pay paid paid  put put put  read read read
ride rode ridden  ring rang rung  run ran run  say said said  see saw seen
sell sold sold  send sent sent  sing sang sung  sit sat sat  sleep slept slept
speak spoke spoken  spend spent spent  stand stood stood  swim swam swum
take took taken  teach taught taught  tell told told  think thought thought
throw threw thrown  understand understood understood  wake woke woken
wear wore worn  win won won  write wrote written
`
  .trim()
  .split(/\s{2,}|\n/u)
  .map((t) => t.trim().split(/\s+/u))
  .filter((t) => t.length === 3) as [string, string, string][];

/** Irregular plurals, and the singulars of the course's plural-only nouns
 *  (boot … vegetable: picked by hand from the system dictionary's matches). */
const NOUNS = `man men woman women child children person people foot feet tooth teeth
mouse mice boot dish eye parent shoe sock trouser vegetable`
  .trim()
  .split(/\s+/u);

/** The regular -s a learner puts on an irregular noun ("mans", "childrens"):
 *  known words, so the slip is grammar, not a typo. */
const NOUN_MISFORMS = 'mans womans childrens tooths foots mouses lifes knifes'.split(' ');

/** All negative short forms — real words, even the ones a lesson never prints. */
export const SHORT_NEGATIVES: readonly string[] = `isn't aren't wasn't weren't don't doesn't
didn't haven't hasn't hadn't won't can't couldn't shouldn't wouldn't mustn't needn't`
  .trim()
  .split(/\s+/u);

/** base · past · participle triples (scripts/practice-rules.ts groups forms of one verb). */
export const IRREGULAR_VERB_TABLE: readonly (readonly [string, string, string])[] = VERBS;
export const IRREGULAR_VERB_FORMS: readonly string[] = VERBS.flat().concat(['were']);
export const IRREGULAR_BASES: readonly string[] = VERBS.map(([base]) => base);
export const IRREGULAR_NOUNS: readonly string[] = NOUNS;
export const IRREGULAR_WORDS: readonly string[] = [...IRREGULAR_VERB_FORMS, ...NOUNS, ...NOUN_MISFORMS];

/** Past forms and participles that are not also a base ("read", "put", "cut",
 *  "come" stay out): none of them takes a grammar -s. */
export const PAST_FORMS: ReadonlySet<string> = new Set(
  VERBS.flatMap(([, past, part]) => [past, part]).filter((f) => !IRREGULAR_BASES.includes(f)),
);
